import React from "react";
import { FaExclamationTriangle, FaPlusCircle, FaLock } from "react-icons/fa";
import { useT } from "../../contexts/TranslationContext";
import { FLAG_TYPES } from "./reportFlagDrafts";

// Missing task is raised from the task picker, where the worker already failed to find
// the task, so it needs no chip of its own here.
const CHIPS = [
  {
    type: FLAG_TYPES.DEVIATION,
    labelKey: "reportFlags.deviation",
    Icon: FaExclamationTriangle,
    iconClass: "text-amber-500",
  },
  {
    type: FLAG_TYPES.ATA,
    labelKey: "reportFlags.ata",
    Icon: FaPlusCircle,
    iconClass: "text-teal-600",
  },
];

/**
 * One row of light chips above the submit button.
 *
 * This is the only cost the feature adds to a day with nothing to report, so it stays a
 * single row: no labels, no fields, and nothing that has to be filled in.
 */
function ReportFlagChips({ drafts = [], onOpen, internalNote = "", onOpenInternalNote }) {
  const { t } = useT();

  const countFor = (type) => drafts.filter((draft) => draft.type === type).length;
  const hasInternalNote = !!String(internalNote || "").trim();

  return (
    <div className="pt-4 border-t">
      <div className="flex flex-wrap gap-2">
        {CHIPS.map(({ type, labelKey, Icon, iconClass = "" }) => {
          const count = countFor(type);
          const active = count > 0;
          return (
            <button
              key={type}
              type="button"
              onClick={() => onOpen(type)}
              aria-label={t(labelKey)}
              className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border text-sm transition-colors ${
                active
                  ? "bg-blue-50 border-blue-300 text-blue-700 font-medium"
                  : "bg-white border-gray-300 text-gray-600 hover:border-blue-400 hover:text-blue-600"
              }`}
            >
              <Icon className={`w-3.5 h-3.5 flex-shrink-0 ${iconClass}`} aria-hidden />
              <span>{t(labelKey)}</span>
              {active && (
                <span className="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-blue-600 text-white text-xs">
                  {count}
                </span>
              )}
            </button>
          );
        })}
        {onOpenInternalNote && (
          <button
            type="button"
            onClick={onOpenInternalNote}
            aria-label={t("report.internalNote")}
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border text-sm transition-colors ${
              hasInternalNote
                ? "bg-slate-100 border-slate-300 text-slate-800 font-medium"
                : "bg-white border-gray-300 text-gray-600 hover:border-slate-400 hover:text-slate-700"
            }`}
          >
            <FaLock className="w-3.5 h-3.5 flex-shrink-0 text-slate-500" aria-hidden />
            <span>{t("report.internalNote")}</span>
            {hasInternalNote && (
              <span className="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-slate-600 text-white text-xs">
                1
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default ReportFlagChips;
